
export default function CommunicationComponent() {
  return (
    <div className="container py-4">
      <h1>Communication</h1>
    </div>
  );
}
